import Pino, { Level } from 'pino';

// @TODO: this should be in a config file but atm frontend cannot build from there for a reason
const enabled = false;
const level: Level = (process.env.LOG_LEVEL as Level) || 'info';

// const prettyPrintOptions: PrettyOptions = { ignore: 'pid,hostname,time,v' };
const prettyPrint = process.env.ENV !== 'production' ? false : false;

export const log = Pino({ name: 'website-frontend', level, prettyPrint, enabled });

// Alias of 'log' to make importing easier
export const logger = log;
